import ContextProperty from 'owa-service/lib/contract/ContextProperty';
import FindPeopleRequest from 'owa-service/lib/contract/FindPeopleRequest';
import FindPeopleResponseMessage from 'owa-service/lib/contract/FindPeopleResponseMessage';
import IndexedPageView from 'owa-service/lib/contract/IndexedPageView';
import PersonaResponseShape from 'owa-service/lib/contract/PersonaResponseShape';
import contextProperty from 'owa-service/lib/factory/contextProperty';
import findPeopleJsonRequest from 'owa-service/lib/factory/findPeopleJsonRequest';
import findPeopleRequest from 'owa-service/lib/factory/findPeopleRequest';
import indexedPageView from 'owa-service/lib/factory/indexedPageView';
import personaResponseShape from 'owa-service/lib/factory/personaResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import findPeopleOperation from 'owa-service/lib/operation/findPeopleOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { FeedbackManagerState } from 'owa-feedback-manager/lib/store/schema/FeedbackManagerState';

const MAX_ENTRIES_DIRECTORY = 20;
const MAX_ENTRIES_TYPEDOWN = 10;
const OWA_COMPOSE_SCENARIO_STRING = 'owa.react.compose';
const OWA_IMPLICIT_GROUP_SCENARIO_STRING = 'NewMail.To';

function configureIndexedPageView(includeDirectory: boolean): IndexedPageView {
    return indexedPageView({
        BasePoint: 'Beginning',
        Offset: 0,
        MaxEntriesReturned: includeDirectory ? MAX_ENTRIES_DIRECTORY : MAX_ENTRIES_TYPEDOWN,
    });
}

interface ContextInfo {
    __type?: string;
    RecipientsTo?: string[];
}

function configureContextInfo(currentRecipients: string[]): ContextInfo {
    return {
        __type: 'FindPeopleContextInfo:#Exchange',
        RecipientsTo: currentRecipients,
    };
}

function configureRequestBody(
    queryString: string,
    includeDirectory: boolean,
    includeImplicitGroups: boolean,
    currentRecipients?: string[]
): FindPeopleRequest {
    let querySources = ['Mailbox'];
    if (includeDirectory) {
        querySources.push('Directory');
    }
    return findPeopleRequest({
        IndexedPageItemView: configureIndexedPageView(includeDirectory),
        PersonaShape: configurePersonaShape(),
        QuerySources: querySources,
        QueryString: queryString,
        SearchPeopleSuggestionIndex: true,
        ShouldResolveOneOffEmailAddress: false,
        IncludeImplicitGroups: includeImplicitGroups,
        Context: configureContext(includeImplicitGroups),
        ContextInfo: configureContextInfo(currentRecipients ? currentRecipients : []),
    });
}

function configurePersonaShape(): PersonaResponseShape {
    let additionalProperties = [
        propertyUri({ FieldURI: 'PersonaEmailAddress' }),
        propertyUri({ FieldURI: 'EmailAddresses' }),
        propertyUri({ FieldURI: 'PersonaDisplayName' }),
        propertyUri({ FieldURI: 'PersonaDisplayNames' }),
        propertyUri({ FieldURI: 'PersonaId' }),
        propertyUri({ FieldURI: 'PersonaType' }),
    ];
    return personaResponseShape({
        BaseShape: 'IdOnly',
        AdditionalProperties: additionalProperties,
    });
}

function configureContext(includeImplicitGroups: boolean): ContextProperty[] {
    let appScenario: string = includeImplicitGroups
        ? OWA_IMPLICIT_GROUP_SCENARIO_STRING
        : OWA_COMPOSE_SCENARIO_STRING;
    return [
        contextProperty({ Key: 'AppName', Value: 'OWA' }),
        contextProperty({ Key: 'AppScenario', Value: appScenario }),
    ];
}

export function findPeople(
    queryString: string,
    includeDirectory: boolean,
    feedbackManager?: FeedbackManagerState,
    includeImplicitGroups?: boolean,
    currentRecipients?: string[]
): Promise<FindPeopleResponseMessage> {
    let requestBody = configureRequestBody(
        queryString,
        includeDirectory,
        includeImplicitGroups,
        currentRecipients
    );
    return findPeopleOperation(
        findPeopleJsonRequest({
            Header: getJsonRequestHeader(),
            Body: requestBody,
        })
    ).then(response => {
        let responseMessage: FindPeopleResponseMessage = response.Body;
        return responseMessage;
    });
}
